import * as React from 'react';
import { ProjectTypeItem } from './ProjectTypeItem';

export const ProjectTypeConfig = {
  expertise_et_conseil: {
    label: 'Expertise & conseil',
    src: 'project/expertise-conseil',
  },
  // tslint:disable-next-line:object-literal-sort-keys
  direction_de_project: {
    label: 'Direction de projet',
    src: 'project/direction-projet',
  },
  gestion_de_projet_it: {
    label: 'Gestion de projet IT',
    src: 'project/gestion-projet-it',
  },
  transformation_digitale: {
    label: 'Transformation digitale',
    src: 'project/transformation-digitale',
  },
  'formation/coaching': {
    label: 'Formation/coaching',
    src: 'project/formation',
  },
  'audit_rh/sirh': { label: 'Audit RH/SIRH', src: 'project/audit' },
};

interface IProjectTypeListProps {
  edit: boolean;
  projectType: string[];
  handleClick: (id: string) => void;
}

export const ProjectTypeList: React.SFC<IProjectTypeListProps> = ({
  edit,
  projectType,
  handleClick,
}) => {
  const isActive = (type: string) => {
    return (projectType as any).includes(type);
  };

  return (
    <div className='d-flex justify-content-between'>
      {Object.keys(ProjectTypeConfig).map((name: string, key: number) => (
        <ProjectTypeItem
          key={key}
          isActive={isActive(ProjectTypeConfig[name].label)}
          name={name}
          src={ProjectTypeConfig[name].src}
          onClick={edit ? handleClick : () => null}
        />
      ))}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/shared/Input/ProjectTypeList.tsx